import Image from 'next/image'
import Router from 'next/router'
import styled from 'styled-components'

import { useUser } from 'providers/UserProvider'

import { Button } from 'components/v2/Button'
import { Column, Row } from 'components/v2/Grid'
import { Modal } from 'components/v2/Modal'
import { Text } from 'components/v2/Text'

const MatchMakerResultsModal = ({
	isOpened,
	setIsOpened,
	submitAvaliation
}) => {
	const { isUserLoggedIn } = useUser()

	return (
		<Modal
			classes='result-modal-matchmaking'
			isOpened={isOpened}
			setIsOpened={setIsOpened}
		>
			{({ innerModalRef }) => (
				<Column ref={innerModalRef} className='justify-center'>
					<Text className='text-center text-[#212121] font-bold'>
						Você gostou das nossas recomendações?
					</Text>
					<Row className='justify-center mt-6 gap-4'>
						<Image
							src={'/static/images/positive-vote.svg'}
							alt='thumbs up'
							onClick={() => submitAvaliation(true)}
							width={46}
							height={46}
						/>
						<Image
							src={'/static/images/negative-vote.svg'}
							alt='thumbs down'
							onClick={() => submitAvaliation(false)}
							width={46}
							height={46}
						/>
					</Row>
					{!isUserLoggedIn && (
						<Column className='items-center justify-center'>
							<HorizontalLine />
							<Text className='text-sm'>Ainda não tem cadastro?</Text>
							<Button
								className='w-[60%] h-10'
								onClick={() => Router.push('/entrar/#getIn')}
							>
								Clique aqui
							</Button>
						</Column>
					)}
				</Column>
			)}
		</Modal>
	)
}

const HorizontalLine = styled.hr`
	margin-top: 24px;
	width: 30%;
	height: 1px;
	border: none;
	border-top: 1px solid #ff7708;
	background-color: #ddd;
`

export { MatchMakerResultsModal }
